export function EmptyState({ title, body, action }: { title: string; body: string; action?: React.ReactNode }) {
  return (
    <div className="rounded-xl border border-dashed border-clinical-line bg-clinical-card p-8 text-center">
      <h3 className="text-base font-semibold text-clinical-ink">{title}</h3>
      <p className="mt-1 text-sm text-clinical-muted">{body}</p>
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}
